import HyperLink from "@/components/functionals/HyperLink.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
//import ImagePerson from "@/components/functionals/ImagePerson.vue";
import DatetimeCobroFormatter from "@/components/functionals/DatetimeColorCobroFormatter.vue";
import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import { formatMonto } from "@/utils";

export const invoicesColumns = (thiss) => [
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    attrs: {
      //   OpenEntryDetails: this.OpenEntryDetails,
      getType: "invoice"
      //   month: 24
    },
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 250
  },

  {
    prop: "Amount",
    label: "Monto",
    sortable: true,
    "sort-method": (a, b) => thiss.sortMonto(a.Amount, b.Amount),
    minWidth: 120,
    formatter: (row) => formatMonto(row.Amount)
  },
  {
    prop: "ClosedDate",
    label: "Fecha de Cobro",
    width: 170,
    formatter: DatetimeCobroFormatter
  },
  // {
  //   prop: "DocumentType",
  //   label: "Estatus",
  //   sortable: true,
  //   minWidth: 120,
  //   formatter: ColorTagsinLineFormatter
  // },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  },
  // {
  //   prop: "DaysLate",
  //   label: "Dias de Retraso",
  //   align: "center",
  //   minWidth: 150,
  //   formatter: SLAClolorStatus
  // },
  {
    prop: "Description",
    label: "Descripcion",
    minWidth: 250
  }
];

export const chargesColumns = (thiss) => [
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    attrs: {
      //   OpenEntryDetails: this.OpenEntryDetails,
      getType: "charges"
      //   month: 24
    },
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 250
  },
  {
    prop: "Amount",
    label: "Monto",
    sortable: true,
    "sort-method": (a, b) => thiss.sortMonto(a.Amount, b.Amount),
    minWidth: 120,
    formatter: (row) => formatMonto(Number(row.Amount))
  },
  // {
  //   prop: "ClosedDate",
  //   label: "Fecha de Cobro",
  //   width: 170,
  //   formatter: DatetimeCobroFormatter
  // },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  },
  // {
  //   prop: "DaysLate",
  //   label: "Dias de Retraso",
  //   align: "center",
  //   minWidth: 150,
  //   formatter: SLAClolorStatus
  // },
  {
    prop: "Description",
    label: "Descripcion",
    minWidth: 260
  }
];
export const KpiChargesColumns = (thiss) => [
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    attrs: {
      //   OpenEntryDetails: this.OpenEntryDetails,
      getType: "KpiCharges"
      //   month: 24
    },
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 250
  },
  {
    prop: "Amount",
    label: "Monto",
    sortable: true,
    "sort-method": (a, b) => thiss.sortMonto(a.Amount, b.Amount),
    minWidth: 120,
    formatter: (row) => formatMonto(Number(row.Amount))
  },
  {
    prop: "ClosedDate",
    label: "Fecha de Cobro",
    width: 170,
    formatter: DatetimeCobroFormatter
  },
  {
    prop: "DocumentTypeKpiCharges",
    label: "Estatus",
    sortable: true,
    minWidth: 140,
    formatter: ColorTagsinLineFormatter
  },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  },
  {
    prop: "DaysLate",
    label: "Dias de Retraso",
    align: "center",
    minWidth: 150,
    formatter: SLAClolorStatus
  }
  // {
  //   prop: "ExecutiveName",
  //   label: "Ejecutivo",
  //   minWidth: 250
  // }
];

export const pendingColumns = (thiss) => [
  /*
{
    prop: "EntryNo",
    label: "No. Registro",
    minWidth: 130,
    sortable: true,
    attrs: {
    OpenEntryDetails: this.OpenEntryDetails,
    getType: this.getType,
    month: 24
    },
    formatter: HyperLink
},
*/
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    attrs: {
      //   OpenEntryDetails: this.OpenEntryDetails,
      getType: "pending"
      //   month: 24
    },
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "PromiseDate",
    label: "Promesa de pago",
    minWidth: 140,
    formatter: DatetimeFormatter
  },
  {
    prop: "DaysLate",
    label: "Dias de Retraso",
    align: "center",
    minWidth: 150,
    formatter: SLAClolorStatus
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 250
  },
  /*
  {
    prop: "ExecutiveName",
    label: "Ejecutivo de Cobros",
    minWidth: 200,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "accountPhotoExec"
    }
    // formatter: row => formatMonto(Number(row.Amount))
  },
  */
  {
    prop: "AmountInDollars",
    label: "Monto",
    sortable: true,
    "sort-method": (a, b) =>
      thiss.sortMonto(a.AmountInDollars, b.AmountInDollars),
    minWidth: 120
    // formatter: row => formatMonto(Number(row.Amount))
  },
  /*
  {
    prop: "ClosedDate",
    label: "Fecha de Cobro",
    width: 170,
    formatter: DatetimeCobroFormatter
  },
  */
  {
    prop: "DocumentType",
    label: "Estatus",
    sortable: true,
    minWidth: 120,
    formatter: ColorTagsinLineFormatter
  },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  },

  /*
    {
    prop: "ChargeDocument",
    label: "Documento de cobro",
    minWidth: 150
    },
    */
  {
    prop: "Contact",
    label: "Contacto",
    minWidth: 150
  },
  {
    prop: "Description",
    label: "Descripcion",
    minWidth: 250
  },
  {
    prop: "LatestComment",
    label: "Último Comentario",
    minWidth: 250
  }
  // {
  //   prop: "CreatedBy",
  //   label: "Usuario",
  //   minWidth: 150
  // }
];

// function parseMonto(value) {
//     if (typeof value === 'number') return value

//     return Number(
//       String(value || '').replace(/[^0-9.-]/g, '')
//     )
//   }

// function  sortMonto(a, b) {
//     return parseMonto(a.monto) - parseMonto(b.monto)
//   }
